"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames2 = _interopRequireDefault(require("classnames"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
} // TODO: Change to height instead of pixels


var Spacer = function Spacer(props) {
  var _classnames;

  var m = props.m,
      mt = props.mt,
      mb = props.mb,
      ml = props.ml,
      mr = props.mr,
      mx = props.mx,
      my = props.my,
      className = props.className;
  var spacerClass = (0, _classnames2["default"])((_classnames = {}, _classnames["m-" + m] = m !== false, _classnames["mt-" + mt] = mt !== false, _classnames["mb-" + mb] = mb !== false, _classnames["ml-" + ml] = ml !== false, _classnames["mr-" + mr] = mr !== false, _classnames["mx-" + mx] = mx !== false, _classnames["my-" + my] = my !== false, _classnames), className);
  return _react["default"].createElement("div", {
    className: spacerClass,
    style: {
      height: '1px',
      width: '1px'
    }
  });
};

Spacer.propTypes = {
  /**
   * Additional classes to be added to the component
   */
  className: _propTypes["default"].string,

  /**
   * Margin to be added to all sides.
   */
  m: _propTypes["default"].number,

  /**
   * Margin to be added to top.
   */
  mt: _propTypes["default"].number,

  /**
   * Margin to be added to bottom.
   */
  mb: _propTypes["default"].number,

  /**
   * Margin to be added to left.
   */
  ml: _propTypes["default"].number,

  /**
   * Margin to be added to right.
   */
  mr: _propTypes["default"].number,

  /**
   * Margin only added to the x axis.
   */
  mx: _propTypes["default"].number,

  /**
   * Margin only added to the y axis.
   */
  my: _propTypes["default"].number
};
Spacer.defaultProps = {
  className: '',
  m: 0,
  mt: 0,
  mb: 0,
  ml: 0,
  mr: 0,
  mx: 0,
  my: 0
};
Spacer.displayName = 'Spacer';
var _default = Spacer;
exports["default"] = _default;